<div>
    <div class="mb-3">Please provide your email address below.</div>
    <div>
        <mat-form-field>
            <input
                #email="ngModel"
                [(ngModel)]="previewEmail"
                [email]="true"
                aria-label="Email"
                matInput
                placeholder="Email"
                type="email"
            />
        </mat-form-field>
        <div *ngIf="email.errors?.email" style="color: red">
            Please enter a valid email address.
        </div>
    </div>
</div>
<div class="mt-2 text-center">
    <button
        [disabled]="!previewEmail || !previewEmail.length"
        (click)="onConfirmClick()"
        class="mr-1"
        color="accent"
        mat-flat-button
    >
        Send Preview Email
    </button>
    <button (click)="closeDialog()" mat-stroked-button>Cancel</button>
</div>
